import { AlertTriangle, Phone as PhoneIcon, Mail } from "lucide-react";

export function MissingBanner({ missing }) {
  if (missing.length === 0) return null;
  return (
    <div
      id="careers-missing-banner"
      className="mb-6 rounded-2xl border-2 border-amber-300 bg-amber-50 p-5 flex gap-4"
      data-testid="careers-missing-banner"
    >
      <AlertTriangle className="w-6 h-6 text-amber-600 shrink-0 mt-0.5"/>
      <div>
        <div className="font-semibold text-amber-900">Please answer these required question{missing.length > 1 ? "s" : ""} before submitting:</div>
        <ul className="list-disc pl-5 mt-2 text-sm text-amber-800 space-y-1">
          {missing.map(([k, label]) => <li key={k} data-testid={`missing-${k}`}>{label}</li>)}
        </ul>
      </div>
    </div>
  );
}

export function ServerErrorBanner({ serverError }) {
  if (!serverError) return null;
  return (
    <div
      id="careers-server-error"
      className="mb-6 rounded-2xl border-2 border-red-300 bg-red-50 p-5"
      data-testid="careers-server-error"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-6 h-6 text-red-600 shrink-0 mt-0.5"/>
        <div className="space-y-2">
          <div className="font-semibold text-red-900">We couldn't submit your application.</div>
          <p className="text-sm text-red-800">Something went wrong on our end. Please try again in a moment, or reach out to us directly and we'll take your application by phone or email.</p>
          <div className="flex flex-wrap gap-4 pt-1">
            <a href="tel:7182162013" className="inline-flex items-center gap-1.5 text-sm font-semibold text-red-900 hover:text-[hsl(var(--primary))]">
              <PhoneIcon className="w-4 h-4"/> 718-216-2013
            </a>
            <a href="mailto:info@sandarsushi.com" className="inline-flex items-center gap-1.5 text-sm font-semibold text-red-900 hover:text-[hsl(var(--primary))]">
              <Mail className="w-4 h-4"/> info@sandarsushi.com
            </a>
          </div>
          <div className="text-xs text-red-600 pt-1">Details: {serverError}</div>
        </div>
      </div>
    </div>
  );
}
